module.exports = __webpack_public_path__ + "static/media/banner.7584e5dd.png";